import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ATTRIBUTE_LABEL } from "../../../Helpers/Labels/AttributeLabel";
import RelationCardinality from "./RelationCardinality";
import RelationCardinalityDropdown from "./RelationCardinalityDropdown";
import { cloneElement } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";

function RecommendedRelationCard({
    selected,
    fromEntityName, toEntityName, cardinality,
    addReferenceAttribute, referenceAttribute, referenceAttributes,
    onCardinalityChange, onAddReferenceAttributeChange, onReferenceAttributeChange,
    onToggle, onSwap
}) {

    const { t } = useTranslation("linked_entity/recommended_relation_card");

    function handleCardinalityChange(e) {
        onCardinalityChange(e);
    }

    function handleAddReferenceAttributeChange(e) {
        e.syntheticEvent.stopPropagation();
        onAddReferenceAttributeChange(e);
    }

    function handleReferenceAttributeChange(e) {
        e.syntheticEvent.stopPropagation();
        onReferenceAttributeChange(e);
    }

    function handleToggle(e) {
        onToggle(e);
    }

    function handleSwap(e) {
        onSwap(e);
    }

    function isValidReferenceAttributesPresent() {
        return referenceAttributes && referenceAttributes.length > 0;
    }

    return (
        <div className="col-4 bg-white px-1">
            <button
                className={`w-100 h-100 bg-white ${selected ? 'border-3 border-primary' : 'border border-secondary'}`}
                onClick={handleToggle}
            >
                <div className={`h-100 d-flex flex-column align-items-center justify-content-center py-1 px-2 w-100`}>
                    <div className="d-flex justify-content-center align-items-center">
                        {
                            cardinality === "1-*" ?
                            <button className="btn font-size-1 hover-border-0" onClick={handleSwap}>
                                <i className="fal fa-exchange h5"></i>
                            </button>
                            :
                            <span className="btn empty-button">&nbsp;&nbsp;</span>
                        }
                        <RelationCardinalityDropdown
                            value={cardinality}
                            onChange={handleCardinalityChange}
                        />
                    </div>
                    <RelationCardinality
                        fromEntityName={fromEntityName}
                        toEntityName={toEntityName}
                        cardinality={cardinality}
                    />
                    <div className="h-75">
                        {
                            cardinality === "1-*" &&
                            isValidReferenceAttributesPresent() ?
                            <label
                                onClick={e => e.stopPropagation()}>
                                <Checkbox
                                    value={addReferenceAttribute}
                                    checked={addReferenceAttribute}
                                    disabled={!isValidReferenceAttributesPresent()}
                                    onChange={handleAddReferenceAttributeChange}
                                    onClick={e => {
                                        e.stopPropagation();
                                    }} />
                                &nbsp;
                                {
                                    t("add_reference_property", {
                                        ns: "linked_entity/recommended_relation_card",
                                        entityName: toEntityName
                                    })
                                }
                            </label>
                            :
                            <>&nbsp;</>
                        }
                        {
                            addReferenceAttribute ?
                            <DropDownList
                                ariaLabel={`Reference ${ATTRIBUTE_LABEL}`}
                                data={referenceAttributes}
                                value={referenceAttribute}
                                valueRender={(element, value) => {
                                    return cloneElement(
                                        element,
                                        { ...element.props },
                                        <span aria-label="reference-attribute-value">
                                            {value}
                                        </span>
                                    )
                                }}
                                onChange={handleReferenceAttributeChange}
                                onOpen={e => {
                                    e.syntheticEvent.stopPropagation();
                                }}
                                onClose={e => {
                                    e.syntheticEvent.stopPropagation();
                                }}
                                disabled={!referenceAttributes || referenceAttributes.length === 0}
                            />
                            :
                            <>&nbsp;</>
                        }
                    </div>
                </div>
            </button>
        </div>
    )
}

/*
<div className="col-4 bg-white px-1">
    <button
        key={index}
        className={`w-100 h-100 bg-white ${relation.selected ? "border-primary border-3" : "border border-secondary"}`}
        onClick={() => toggleCheckbox(index)}
        disabled={relation.isStatic}
    >
        <div className={`h-100 d-flex flex-column align-items-center justify-content-center py-1 px-2`}>
            <div className="btn border-0 w-100" onClick={() => toggleCheckbox(index)}>
                <SelectedCardinality
                    selected={relation.cardinality}
                    firstEntityName={relation.from}
                    secondEntityName={relation.to} />
            </div>
            <div>
                {
                    relation.cardinality === "1-*"
                    ?
                    <label
                        onClick={e => e.stopPropagation()}>
                        <Checkbox
                            value={relation.showReferenceAttribute}
                            checked={relation.showReferenceAttribute}
                            disabled={relation.isStatic}
                            onChange={(e) => {
                                e.syntheticEvent.stopPropagation();
                                e.nativeEvent.stopPropagation();
                                toggleShowReferenceAttribute(index)
                            }}
                            onClick={e => {
                                debugger;
                                e.stopPropagation()
                            }} />
                        &nbsp;
                        Add Reference {ATTRIBUTE_LABEL}
                    </label>
                    :
                    <>&nbsp;</>
                }
                {
                    relation.showReferenceAttribute
                    ?
                    <DropDownList
                        data={getSelectedAttributeNameOfEntity(relation.from)}
                        value={relation.referenceAttribute}
                        disabled={relation.isStatic}
                        onChange={(e) => handleReferenceAttributeChange(e, index)}
                        onOpen={e => {
                            e.syntheticEvent.stopPropagation();
                        }}
                        onClose={e => {
                            e.syntheticEvent.stopPropagation();
                        }} />
                    :
                    <>&nbsp;</>
                }
            </div>
        </div>
    </button>
</div>
*/

export default RecommendedRelationCard;